module.exports = __webpack_public_path__ + "static/images/biditem2_f6dd39c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem2.png
// module id = 242
// module chunks = 1